<template id="">
    <aside class="md:min-h-screen flex md:hidden flex-col items-center shadow aside--mobile">
        <ul class="w-full md:mt-20 flex md:block justify-center items-center py-2 py:md-0">
            <li class="px-3">
                <router-link
                        :to="{ name: 'dashboard' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-tachometer-fast"></i>
                    <span class="text-sm mt-1">
                        Dashboard
                    </span>
                </router-link>
            </li>

            <li class="px-3">
                <router-link
                        :to="{ name: 'bookServiceCall' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-wrench"></i>
                    <span class="text-sm mt-1">
                        Service
                    </span>
                </router-link>
            </li>
            <li class="px-3">
                <router-link
                        :to="{ name: 'orderConsumables' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-tint"></i>
                    <span class="text-sm mt-1">
                        Order
                    </span>
                </router-link>
            </li>

            <li class="px-3">
                <router-link
                        :to="{ name: 'meterReadings' }"
                        active-class="active"
                        class="nav-router-link flex-col w-16 md:w-12 h-12">
                    <i class="fas fa-print"></i>
                    <span class="text-sm mt-1">
                        Meter
                    </span>
                </router-link>
            </li>

        </ul>
    </aside>
</template>
<script charset="utf-8">

    export default {
        data() {
            return {
                isActive: false
            }
        },

        methods: {

        }
    }
</script>

